var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"common-bar-button fb-start-center c-006AFE font-34",on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"iconfont mr-8 font-48"},[_vm._t("icon",function(){return [_vm._v("")]})],2),_c('span',{staticClass:"common-bar-button__text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }